import { ChangeEvent, useCallback } from "react";

import { useSelectorLogic } from "../selectorHook";
import { DdlValue, Props } from "../types";
import DropDownMarkup from "./markup";

function DropDownList(props: Props) {
	const { value, setValueFn: setValue } = useSelectorLogic(props);

	const onSelectChange = useCallback(
		function (event: ChangeEvent<HTMLSelectElement>) {
			const ddlValue = event.target.value === "" ? null : event.target.value;
			const value = isNaN(parseInt(ddlValue)) ? ddlValue : parseInt(ddlValue);
			setValue({ value: value } as DdlValue);
		},
		[setValue],
	);

	return <DropDownMarkup {...props} onChange={onSelectChange} value={value} />;
}

export default DropDownList;
